import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFlowStepperStep, getPartialSteps } from 'components/Steps/thunk'
import { addBackUrl, hideFooterBlock } from 'components/Footer/thunk'
import { LoaderSpinner } from 'components/Loader'
import RefundPopup from './components/RefundPopup'
import RefundFinalPopup from './components/RefundFinalPopup'
import ExchangeFinalPopup from './components/ExchangeFinalPopup'
import Layout from 'components/Layout'
import StepsAnimation from 'components/StepsAnimation'
import config from 'configs/config'
import { clearState } from './slices'
import { cleanItems } from 'components/Steps/slices'
import { SS } from 'utils/common'
import { getCartFinal } from './thunk'
import { find } from 'lodash'

const Refund = ({ match }) => {
	const dispatch = useDispatch()
	const {
		partialRequestData = {},
		flowStep,
		prevFlowStep,
		totals = {},
		items = {},
		isLoading,
		shipmentOptions,
	} = useSelector(({ steps }) => steps)
	const isRefundLoading = useSelector(({ refund }) => refund.isLoading)
	const { instructions = [], wasCartResponseReceived = false } = useSelector(
		({ refund }) => refund
	)

	/**
	 * getCurrency {Function}
	 * @getCurrency - get currency
	 * @return {String}
	 *
	 * */
	const getCurrency = (partialRequestData) => {
		let currentItem =
			partialRequestData &&
			partialRequestData.returnOrder &&
			partialRequestData.returnOrder.items
				? partialRequestData?.returnOrder?.items[0]
				: null
		let selectedItem = null
		let props = SS.get('shopProperties')
		let defaultCurrency =
			props && props['default.currency'] ? props['default.currency'] : ''

		if (!selectedItem && currentItem) {
			selectedItem =
				items && items.exchange
					? items.exchange[currentItem?.orderItemId]
					: null
		}

		if (!selectedItem && currentItem) {
			selectedItem =
				items && items.reclamation
					? items.reclamation[currentItem?.orderItemId]
					: null
		}

		if (!selectedItem && currentItem) {
			selectedItem =
				items && items.refund
					? items.refund[currentItem?.orderItemId]
					: null
		}

		if (!selectedItem && currentItem) {
			selectedItem =
				items && items.newExchange
					? items.newExchange[currentItem?.orderItemId]
					: null
		}

		return selectedItem && selectedItem.currency
			? selectedItem.currency
			: defaultCurrency
	}
	/**
	 * isShippingOptionSelected {Function}
	 * @description - check is shipping option was selected
	 * @return {Boolean}
	 *
	 * */
	const isShippingOptionSelected = () => {
		return (
			partialRequestData &&
			partialRequestData.shippingOptionId &&
			partialRequestData.shippingOptionLabelsAmount
		)
	}

	/**
	 * isShipmentOptionInStore {Function}
	 * @description - get data if shipping option was selected as IN_STORE
	 * @return {Object}
	 *
	 * */
	const getShipmentOptionInStoreData = () => {
		let shipmentOptionId =
			partialRequestData && partialRequestData.shippingOptionId
		let selectedOption = shipmentOptionId
			? find(
					shipmentOptions,
					(shipmentOption) => shipmentOption.id === shipmentOptionId
			  )
			: null

		if (
			selectedOption &&
			(selectedOption.type === 'IN_STORE' ||
				selectedOption.type === 'RETURN_TO_STORE')
		) {
			return {
				type: selectedOption.type,
				selected: true,
			}
		} else {
			return {
				selected: false,
			}
		}
	}

	useEffect(() => {
		dispatch(setFlowStepperStep('REFUND'))
	}, [])

	// send continue partial request on did mount action
	useEffect(() => {
		if (flowStep === config.flowSteps.REFUND) {
			console.log('flowStep Refund', flowStep)
			dispatch(getPartialSteps(partialRequestData))
		}
	}, [flowStep])

	useEffect(() => {
		dispatch(addBackUrl(prevFlowStep))
	}, [prevFlowStep])

	useEffect(() => {
		if (wasCartResponseReceived) {
			dispatch(hideFooterBlock({}))
			SS.set('wasItemsHandled', 1)
		}
	}, [wasCartResponseReceived])

	useEffect(() => {
		//in case of refundTotal equal 0 need to send final request automatically
		if (totals && totals.refundTotal === 0) {
			dispatch(getCartFinal(partialRequestData))
		}
		return function clean() {
			if (SS.get('wasItemsHandled') === 1) {
				dispatch(clearState())
				dispatch(cleanItems())
				SS.remove('wasItemsHandled')
			}
		}
	}, [])

	let isShoppingOptionExist = isShippingOptionSelected()
	return (
		<Layout>
			<StepsAnimation>
				{!!(isLoading || isRefundLoading) && (
					<LoaderSpinner isActive={true} />
				)}
				{!wasCartResponseReceived ? (
					<RefundPopup
						totals={totals}
						partialRequestData={partialRequestData}
						currency={getCurrency(partialRequestData)}
					/>
				) : (
					<>
						{!!(
							items &&
							items.newExchange &&
							Object.keys(items.newExchange).length
						) ? (
							<ExchangeFinalPopup
								instructions={instructions}
								totals={totals}
								items={items}
								currency={getCurrency(partialRequestData)}
								isShippingOptionSelected={isShoppingOptionExist}
								shipmentOptionInStore={getShipmentOptionInStoreData()}
							/>
						) : (
							<RefundFinalPopup
								instructions={instructions}
								totals={totals}
								currency={getCurrency(partialRequestData)}
								isShippingOptionSelected={isShoppingOptionExist}
								shipmentOptionInStore={getShipmentOptionInStoreData()}
							/>
						)}
					</>
				)}
			</StepsAnimation>
		</Layout>
	)
}

export default Refund
